import verticalBarChartSpec, {
  addFilterSignalBarChart,
} from "utils/verticalBarChartSpec";
import histogramSpec, { addFilterSignal } from "utils/histogramSpec";
import vegaEmbed from "vega-embed";
import { compile } from "vega-lite/build/vega-lite";

export function prepareData(records) {
  if (records.length <= 0) {
    return [];
  }
  const data = records[0].questions.reduce((acc, d) => {
    if (!acc[d.question]) {
      acc[d.question] = {
        chartType: "barchart",
        data: [],
      };
    }
    acc[d.question].domain = d.options.map((o) => o.label);
    return acc;
  }, {});

  const addData = (question, record, data) => {
    // console.log(data, question, record);
    question.options.map((o) => {
      let questionData = data[question.question].data; // array
      if (question.type === "checkbox") {
        if (o.checked) {
          questionData.push({
            responseId: record.id,
            school: record,
            [question.question]: o.label,
            type: question.question,
          });
        }
      } else {
        if (question.selected === o.label) {
          questionData.push({
            responseId: record.id,
            school: record,
            [question.question]: o.label,
            type: question.question,
          });
        }
      }
    });
  };
  records.map((record) => {
    record.questions.map((question) => addData(question, record, data));
  });
  return data;
}

export function createCharts(
  data,
  containers,
  setTotalCallback = ()=>{},
  markColor = "#00bfa5",
  highlightColor = "#ffab00"
) {
  const charts = [];
  Object.entries(data).map(async (d, i) => {
    const question = d[0];

    // const domain = d[1].dp,aom;
    // console.log(question, domain);

    let chartData = d[1].data; //data.filter((d) => d.type === question);
    // console.log(chartData, question, domain);
    // chartData = JSON.parse(JSON.stringify(chartData))
    // console.log(chartSpec);
    const chartType = d[1].chartType;
    const domain = d[1].domain;
    let chart;

    if (chartType === "histogram") {
      const chartSpec = histogramSpec(
        chartData,
        question,
        null,
        markColor,
        highlightColor
      );
      let vegaSpec = compile(chartSpec).spec;
      addFilterSignal(vegaSpec);
      chart = await vegaEmbed(containers[i], vegaSpec);
    } else {
      const chartSpec = verticalBarChartSpec(
        chartData,
        question,
        domain,
        "Number of Responses",
        null,
        markColor,
        highlightColor
      );
      const vegaSpec = compile(chartSpec).spec;
      addFilterSignalBarChart(vegaSpec);
      chart = await vegaEmbed(containers[i], vegaSpec);
    }
    charts.push(chart);

    chart.view.addSignalListener("select", (name, value) => {
      console.log(question, value)
      // filter data
      // 1. filter data and get the corresponding responses
      // pre-compute combine data
      const combined = Object.values(data)
        .map((d) => d.data)
        .flat();
      let allIds = combined
        .filter(
          (d) =>
            d.type === question &&
            value[question] &&
            (chartType === "histogram"
              ? value[question][0] <= d[question] &&
                d[question] <= value[question][1]
              : value[question].includes(d[question]))
        )
        .reduce((acc, record) => {
          acc[record.responseId] = true;
          return acc;
        }, {});

      // 2. extrapolate the response IDs to include other data
      setTotalCallback(allIds.length);
      allIds = combined.filter((d) => allIds[d.responseId]);

      Object.entries(data).map((d, i) => {
        // get responses per each question
        const ids = allIds
          .filter((f) => f.type === d[0])
          .map((d) => d.responseId);
        try {
          // console.log("filter selection", charts[i].view.signal("filter_selection"));
          charts[i].view.signal("filter_selection", ids).runAsync();
        } catch (err) {
          console.error(err, charts[i].view.getState());
        }
      });
    });
  });
}
export default {
  createCharts,
};
